import { Box, styled } from 'fbm-ui';
import { Slider } from 'fbm-ui/lib/mui';
export var StyledSlider = styled(Slider)(function (_a) {
    var theme = _a.theme;
    return ({
        color: theme.palette.primary.main,
        height: 8,
        '& .MuiSlider-rail': {
            backgroundColor: '#ECEFF1',
        },
        '& .MuiSlider-track': {
            border: 'none',
            backgroundColor: theme.palette.primary.main,
        },
        '& .MuiSlider-thumb': {
            height: 24,
            width: 24,
            backgroundColor: '#fff',
            border: '2px solid currentColor',
            zIndex: 2,
            '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
                boxShadow: 'inherit',
            },
            '&:before': {
                display: 'none',
            },
        },
        '& .MuiSlider-valueLabel': {
            lineHeight: 1.2,
            fontSize: 12,
            background: 'unset',
            padding: 0,
            width: 34,
            height: 34,
            borderRadius: '50% 50% 50% 0',
            backgroundColor: theme.palette.primary.main,
            transformOrigin: 'bottom left',
            transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
            '&:before': { display: 'none' },
            '&.MuiSlider-valueLabelOpen': {
                transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
            },
            '& > *': {
                transform: 'rotate(45deg)',
            },
        },
    });
});
export var ScoreSliderRoot = styled(Box)({
    display: 'flex',
    alignItems: 'center',
});
export var QuestionDesc = styled(Box)({
    minHeight: 34,
    padding: 8,
    background: '#F9FAF9',
    position: 'relative',
    borderRadius: 2,
    marginTop: 16,
    '& >.MuiSvgIcon-root': {
        position: 'absolute',
        left: 8,
        top: -6,
        color: 'rgb(230, 230, 230)',
        // transform: 'rotate(180deg)',
    },
});
export var AiScoreRoot = styled(Box)({
    width: 24,
    height: 24,
    boxShadow: '0px 9px 28px rgba(0,0,0, 0.05), 0px 6px 16px rgba(0,0,0, 0.08), 0px 3px 6px rgba(0,0,0, 0.12)',
    backgroundColor: 'rgba(255, 255, 255, 0.6)',
    position: 'absolute',
    zIndex: 2,
    top: 0,
    bottom: 0,
    borderRadius: '50%',
    margin: 'auto 0',
});
export var RankingRoot = styled(Box)({
    height: 8,
    border: '1px solid rgb(200, 230, 201)',
    position: 'absolute',
    boxSizing: 'border-box',
    top: 13,
    zIndex: 1,
    '&:hover': {
        border: '1px solid #fff',
        boxShadow: '0px 0px 4px 0px rgba(0 0 0 / 50%)',
    },
});
export var Image = styled('img')({
    width: 48,
    height: 84,
    borderRadius: 4,
    objectFit: 'contain',
});
